import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'antd';
import { Button } from '@cropler/ui-kit';
import styles from './styles.module.scss';
import stylesModal from '../../styles/modal.module.scss';

import { listDeviceParametersSoilSensor } from '../../utils/sensors';
import { DeviceInfoItem } from '../GlobalComponents/index.jsx';
import { sensorsApi, useDeleteSensorSettingsSoilSensorMutation } from '../../store/api/sensors';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const SoilSensorInfo = ({ deviceData, t, onClickDisconnect }) => {
  const dispatch = useDispatch();
  const data = listDeviceParametersSoilSensor({ device: deviceData, t });
  const [isDisconnectModalOpen, setIsDisconnectModalOpen] = useState(false);
  const [formError, setFormError] = useState('');

  // const [
  //   updateSoilSensor,
  //   { isSuccess: isUpdateSoilSensorSuccess, isError: isUpdateSoilSensorError, error: updateSoilSensorError },
  // ] = useUpdateSensorSettingsSoilSensorMutation();

  const [
    deleteSoilSensor,
    { isSuccess: isUpdateSoilSensorSuccess, isError: isUpdateSoilSensorError, error: updateSoilSensorError },
  ] = useDeleteSensorSettingsSoilSensorMutation();

  const onDisconnect = () => {
    deleteSoilSensor({ id: deviceData.id });
  };

  // Success, close modal
  useEffect(() => {
    if (!isUpdateSoilSensorSuccess) return;
    dispatch(sensorsApi.util.resetApiState());
    setIsDisconnectModalOpen(false);
    onClickDisconnect();
  }, [isUpdateSoilSensorSuccess]);

  // Errors
  useEffect(() => {
    if (isUpdateSoilSensorError && updateSoilSensorError) {
      setFormError(updateSoilSensorError[0].detail);
    } else {
      setFormError('');
    }
  }, [isUpdateSoilSensorError, updateSoilSensorError]);

  return (
    <>
      <div>
        <div className={styles.soilSensorInfo}>
          {data &&
            data.length > 0 &&
            data.map((item, index) => <DeviceInfoItem key={index} title={item.title} value={item.data} />)}
        </div>
        <div>
          <Button type="secondary" icon={<CroplerIcon name="bluetooth" />} onClick={() => setIsDisconnectModalOpen(true)}>
            {t('soil.disconnect.button')}
          </Button>
        </div>
      </div>

      <Modal
        title={t('soil.disconnect.title')}
        open={isDisconnectModalOpen}
        onCancel={() => setIsDisconnectModalOpen(false)}
        footer={false}
        centered
        width={460}
      >
        <p className={styles.soilSensorDisconnectText}>
          {t('soil.disconnect.text')} <strong>{deviceData.params.serial_number}</strong>
        </p>
        {formError && <p className={styles.formErrors}>{formError}</p>}
        <div className={stylesModal.modalNav}>
          <Button type="secondary" onClick={() => setIsDisconnectModalOpen(false)}>
            {t('actions.cancel')}
          </Button>
          <Button type="danger" icon={<CroplerIcon name="bluetooth" />} onClick={onDisconnect}>
            {t('actions.disconnect')}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default SoilSensorInfo;
